/**
 * Selected approvers of an In Progress job get read access to ATS Tracking (the candidates who
 * applied to their jobs) without needing the ATS role permission. The server sets the flag at
 * login / token check from the job data and enforces the real scope on every request; this flag
 * only decides whether the menu entry and route are shown.
 */
const STORAGE_KEY = "isAtsApprover";

/** Whether the logged-in user approves at least one In Progress job. */
export const isAtsApproverUser = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch (error) {
    return false;
  }
};

/** Remember the flag the server sent with the login or token-check response. */
export const saveAtsApproverFlag = (value) => {
  try {
    localStorage.setItem(STORAGE_KEY, value === true ? "true" : "false");
  } catch (error) {
    // storage unavailable: the user simply keeps the permission-based menu
  }
};

/** The one ATS page approvers may open: ATS Tracking (list and candidate page). */
export const isAtsTrackingPath = (path = "") => /\/ats-tracking(\/|$)/i.test(String(path || ""));
